module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Ga-Ha-Ia.ef51d6eb.png";